'use strict';

(function () {
    var CaptionConverter = ft_Page.extend({
        constructor: function constructor(converterOptions) {
            // converterOptions
            //  exportableTypes : CaptionFileType[]
            //  path : string
            //  container: string
            //  filestackKey: string
            //  filestackPolicy: string
            //  filestackSignature: string

            var self = this;
            this.converterOptions = converterOptions;

            //Knockout viewmodel
            self.viewModel = new window.CaptionConverterModel(converterOptions.exportableTypes);
            ko.applyBindings(self.viewModel);

            //Subscriptions
            self.viewModel.convertPossible.subscribe(function (newValue) {
                if (!newValue) return;

                self.viewModel.overlayOn(true);

                var timeline = new TimelineLite();

                function makeTimeline(num) {
                    var tl = new TimelineLite();
                    tl.to('end', 1, { top: num });
                    return tl;
                }

                timeline.add(makeTimeline(100)).from('.green', timeline.duration(), {
                    width: 0,
                    ease: window.Linear.easeNone,
                    onComplete: function onComplete() {
                        self.viewModel.overlayOn(false);
                        self.viewModel.stepsBarVisible(false);
                    }
                }, 0).timeScale(2);
            });

            //Event handlers
            $('#upload-srt-caption-converter-button').click(function (e) {
                e.preventDefault();
                window.loadInkPicker(self.converterOptions.filestackKey, self.converterOptions.filestackPolicy, self.converterOptions.filestackSignature);
                var picker = window.filepickerClient.picker({
                    fromSources: window.FilePickerSettings.fromSources,
                    uploadInBackground: false,
                    storeTo: {
                        container: self.converterOptions.container,
                        path: self.converterOptions.path,
                        region: self.converterOptions.region
                    },
                    accept: '.srt',
                    maxFiles: window.FilePickerSettings.maxFiles,
                    onUploadDone: function onUploadDone(pickerResponse) {
                        if (pickerResponse.filesUploaded && pickerResponse.filesUploaded.length > 0) {
                            _.forEach(pickerResponse.filesUploaded, function (inkBlob) {
                                var file = new window.InkFile(inkBlob.filename, inkBlob.key);
                                self.viewModel.files.push(file);
                                self.viewModel.checkValidSrt(file);
                            });
                        }
                        if (pickerResponse.filesFailed && pickerResponse.filesFailed.length > 0) {
                            ft_Modal.alert({
                                html: 'An error occured.  Please try again later.',
                                buttons: ['OK']
                            });
                        }
                    }
                });
                picker.open();
            });

            if (window.analytics) {
                $('#upload-srt-caption-converter-button').click(function (event) {
                    window.analytics.track('Button Click', {
                        'altEventName': 'CaptionConverter: Upload Caption File',
                        'stateChange': 'Filestack Modal Open',
                        'locationUrl': '' + window.location.href,
                        'buttonText': 'Select SRT file',
                        'buttonLocation': 'Main Page'
                    });
                });

                $('#convert-button').click(function () {
                    window.analytics.track('Button Click', {
                        'altEventName': 'CaptionConverter: Convert',
                        'stateChange': 'Redirectless page change',
                        'locationUrl': '' + window.location.href,
                        'buttonText': 'Convert',
                        'buttonLocation': 'Main Page (after file uploaded)'
                    });
                });

                $('#convert-again-button').click(function () {
                    window.analytics.track('Button Click', {
                        'altEventName': 'CaptionConverter: Convert Again',
                        'stateChange': 'Redirectless page change',
                        'locationUrl': '' + window.location.href,
                        'buttonText': 'Convert another file',
                        'buttonLocation': 'Main Page (after file converted)'
                    });
                });
            }
        }
    });

    // Exports
    window.CaptionConverter = CaptionConverter;
})();